const header = {
  choosePharmacy: 'Apotheke wählen',
  pharmacyIcon: 'Apotheke-Symbol',
  searchbar: {
    inputLabelShort: 'Medikament suchen...',
    inputLabelLong: 'Medikament suchen (Produktname, PZN...)',
    packaging: 'Packungsgröße',
  },
}

export default header
